<header class="course-content-header">
  <mat-icon class="back-button" (click)="confirmCancelEditCourseContent()">arrow_back</mat-icon>
  <h2 class="course-content-header__title">Contenido de {{ courseName }}</h2>
  <div class="course-content-header__actions">
    <button
      class="btn-bulk-ai"
      [class.btn-bulk-ai--disabled]="isBulkGenerating || isLoadingCourse"
      [disabled]="isBulkGenerating || isLoadingCourse"
      (click)="openBulkModal()"
    >
      <mat-icon svgIcon="other_icons" class="btn-bulk-ai__icon"></mat-icon>
      Generar resúmenes IA
    </button>
    @if (quizFeatureEnabled()) {
      <button
        class="btn-bulk-ai"
        [class.btn-bulk-ai--disabled]="isBulkQuizGenerating || isLoadingCourse"
        [disabled]="isBulkQuizGenerating || isLoadingCourse"
        (click)="onBulkQuizGenerate()"
      >
        <app-enfaf-icon svgIconName="check-circle" iconSize="24px"></app-enfaf-icon>
        Generar autoevaluaciones IA
      </button>
    }
  </div>
</header>

<app-bulk-notes-generation-modal
  [courseId]="courseId ?? ''"
  [isVisible]="isBulkModalVisible"
  (closed)="closeBulkModal()"
  (generationStarted)="onBulkGenerationStarted()"
>
</app-bulk-notes-generation-modal>

<app-bulk-quiz-generation-modal
  [courseId]="courseId ?? ''"
  [isVisible]="isBulkQuizModalVisible"
  (closed)="closeBulkQuizModal()"
  (generationStarted)="onBulkQuizGenerationStarted()"
>
</app-bulk-quiz-generation-modal>

<!-- Inline progress banner (y7wH5 / Nf4XU) -->
@if (bulkBannerState === 'generating') {
  <div class="bulk-progress-banner bulk-progress-banner--loading">
    <div class="bulk-progress-banner__inner">
      <div class="bulk-progress-banner__left">
        <span class="bulk-progress-banner__spinner"></span>
        <div class="bulk-progress-banner__texts">
          <span class="bulk-progress-banner__title">Puedes seguir trabajando...</span>
          <span class="bulk-progress-banner__subtitle">
            Generando resúmenes en segundo plano
            @if (bulkTotalCount > 0) {
              ({{ bulkCompletedCount }}/{{ bulkTotalCount }})
            }
          </span>
        </div>
      </div>
      @if (bulkTotalCount > 0) {
        <span class="bulk-progress-banner__percent"> {{ (bulkCompletedCount / bulkTotalCount) * 100 | number: '1.0-0' }}% </span>
      }
    </div>
  </div>
}

@if (bulkBannerState === 'done') {
  <div
    class="bulk-progress-banner"
    [class.bulk-progress-banner--done]="bulkErrorCount === 0 && bulkSuccessCount > 0"
    [class.bulk-progress-banner--partial]="bulkErrorCount > 0 && bulkSuccessCount > 0"
    [class.bulk-progress-banner--error]="bulkSuccessCount === 0 && bulkErrorCount > 0"
  >
    <div class="bulk-progress-banner__inner">
      <div class="bulk-progress-banner__left">
        @if (bulkErrorCount === 0) {
          <img src="assets/icon/check-green.svg" class="bulk-progress-banner__check-img" alt="" aria-hidden="true" />
        } @else {
          <mat-icon class="bulk-progress-banner__warn-icon">warning</mat-icon>
        }
        <div class="bulk-progress-banner__texts">
          @if (bulkErrorCount === 0) {
            <span class="bulk-progress-banner__title">{{ bulkSuccessCount }}/{{ bulkTotalCount }} resúmenes generados correctamente</span>
          } @else if (bulkSuccessCount > 0) {
            <span class="bulk-progress-banner__title">{{ bulkSuccessCount }}/{{ bulkTotalCount }} resúmenes generados</span>
            <span class="bulk-progress-banner__subtitle"
              >· {{ bulkErrorCount }} no se
              {{
                bulkErrorCount === 1
                  ? 'pudo
          generar'
                  : 'pudieron generar'
              }}
              por error — Pendiente de revisión</span
            >
          } @else {
            <span class="bulk-progress-banner__title">No se han podido generar los resúmenes</span>
            <span class="bulk-progress-banner__subtitle">· {{ bulkErrorCount }}/{{ bulkTotalCount }} fallaron — Pendiente de revisión</span>
          }
        </div>
      </div>
      <div class="bulk-progress-banner__right">
        @if (bulkErrorCount === 0) {
          <span class="bulk-progress-banner__percent">100%</span>
        }
        <button class="bulk-progress-banner__dismiss" (click)="dismissBulkBanner()" aria-label="Cerrar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
}

<!-- Bulk quiz progress banner -->
@if (bulkQuizBannerState === 'generating') {
  <div class="bulk-progress-banner bulk-progress-banner--loading">
    <div class="bulk-progress-banner__inner">
      <div class="bulk-progress-banner__left">
        <span class="bulk-progress-banner__spinner"></span>
        <div class="bulk-progress-banner__texts">
          <span class="bulk-progress-banner__title">Generando autoevaluaciones...</span>
          <span class="bulk-progress-banner__subtitle">
            Generando autoevaluaciones en segundo plano
            @if (bulkQuizTotalCount > 0) {
              ({{ bulkQuizCompletedCount }}/{{ bulkQuizTotalCount }})
            }
          </span>
        </div>
      </div>
      @if (bulkQuizTotalCount > 0) {
        <span class="bulk-progress-banner__percent">{{ (bulkQuizCompletedCount / bulkQuizTotalCount) * 100 | number: '1.0-0' }}%</span>
      }
    </div>
  </div>
}

@if (bulkQuizBannerState === 'done') {
  <div
    class="bulk-progress-banner"
    [class.bulk-progress-banner--done]="bulkQuizErrorCount === 0 && bulkQuizSuccessCount > 0"
    [class.bulk-progress-banner--partial]="bulkQuizErrorCount > 0 && bulkQuizSuccessCount > 0"
    [class.bulk-progress-banner--error]="bulkQuizSuccessCount === 0 && bulkQuizErrorCount > 0"
  >
    <div class="bulk-progress-banner__inner">
      <div class="bulk-progress-banner__left">
        @if (bulkQuizErrorCount === 0) {
          <img src="assets/icon/check-green.svg" class="bulk-progress-banner__check-img" alt="" aria-hidden="true" />
        } @else {
          <mat-icon class="bulk-progress-banner__warn-icon">warning</mat-icon>
        }
        <div class="bulk-progress-banner__texts">
          @if (bulkQuizErrorCount === 0) {
            <span class="bulk-progress-banner__title"
              >{{ bulkQuizSuccessCount }}/{{ bulkQuizTotalCount }} autoevaluaciones generadas correctamente</span
            >
          } @else if (bulkQuizSuccessCount > 0) {
            <span class="bulk-progress-banner__title">{{ bulkQuizSuccessCount }}/{{ bulkQuizTotalCount }} autoevaluaciones generadas</span>
            <span class="bulk-progress-banner__subtitle"
              >· {{ bulkQuizErrorCount }} no {{ bulkQuizErrorCount === 1 ? 'pudo' : 'pudieron' }} generarse por error — Pendiente de revisión</span
            >
          } @else {
            <span class="bulk-progress-banner__title">No se han podido generar las autoevaluaciones</span>
            <span class="bulk-progress-banner__subtitle">· {{ bulkQuizErrorCount }}/{{ bulkQuizTotalCount }} fallaron — Pendiente de revisión</span>
          }
        </div>
      </div>
      <div class="bulk-progress-banner__right">
        @if (bulkQuizErrorCount === 0) {
          <span class="bulk-progress-banner__percent">100%</span>
        }
        <button class="bulk-progress-banner__dismiss" (click)="dismissBulkQuizBanner()" aria-label="Cerrar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
}

<div class="course-content-container">
  @if (isLoadingCourse) {
    <div class="loading-course-container">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  }

  @if (!isLoadingCourse && courseForm) {
    <form class="course-content" [formGroup]="courseForm">
      <!-- Calendario y planificación del curso: siempre visible, fuera de la jerarquía Año/Asignatura -->
      <mat-accordion>
        <mat-expansion-panel class="course-accordion section-accordion calendar-accordion" #calendarPanel>
          <mat-expansion-panel-header class="course-accordion__header section-header">
            <div class="course-accordion__title-container section-title-container">
              <div class="course-accordion__left">
                <div class="course-accordion__text">Calendario y planificación del curso</div>
              </div>

              <div class="course-accordion__actions">
                @if (calendarLocalFile || calendarCurrentFile) {
                  <app-enfaf-icon
                    svgIconName="trash"
                    [isButton]="true"
                    class="course-accordion__trash-icon"
                    iconSize="21px"
                    (click)="$event.stopPropagation()"
                    (onClick)="confirmDeleteCalendar()"
                  ></app-enfaf-icon>
                }

                <button type="button" class="course-accordion__nav-button">
                  <mat-icon class="course-accordion__chevron-icon" [class.rotated]="calendarPanel.expanded"> expand_more </mat-icon>
                </button>
              </div>
            </div>
          </mat-expansion-panel-header>
          <div class="calendar-upload-section">
            <p class="calendar-upload-hint">
              Añade aquí la imagen de planificación del curso. Esta imagen se mostrará en la navegación lateral del curso
              <br />
              y ayudará a los alumnos a orientarse con la planificación y las fechas del curso.
            </p>
            <app-enfaf-input-single-file-dragger-dark
              accept=".png,.jpg,.jpeg,.webp,.pdf"
              [height]="calendarLocalFile || calendarCurrentFile ? '300px' : '200px'"
              [maxFileSize]="10485760"
              [localFile]="calendarLocalFile"
              [currentFile]="calendarCurrentFile"
              [suspendInlinePreview]="isCalendarPreviewOpen"
              (filesDropped)="onCalendarFileDropped($event)"
              (previewClicked)="openCalendarPreview($event)"
              (removeClicked)="confirmDeleteCalendar()"
            ></app-enfaf-input-single-file-dragger-dark>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Shared asignatura accordion markup, reused unchanged both for standard/flash courses (flat list
         below) and for FP courses (nested one level inside each "Año" panel) — see fp-courses-design-references.md
         §0: an Año block must reuse the exact same visual pattern already used by asignatura, just applied one
         level up, wrapping the existing asignaturas rather than redesigning them. -->
      <ng-template #sectionPanelTpl let-i="i" let-sectionGroup="sectionGroup" let-dragDisabled="dragDisabled">
        @if (sectionGroup) {
          <mat-expansion-panel
            cdkDrag
            [cdkDragDisabled]="!!dragDisabled"
            (cdkDragStarted)="onSectionDragStarted(i)"
            class="course-accordion section-accordion"
            [class.invalid]="isSectionInvalid(i)"
            #sectionPanel
            [expanded]="expandedSections[i]"
            (opened)="onSectionExpand(i)"
            (closed)="expandedSections[i] = false"
          >
            <mat-expansion-panel-header cdkDragHandle class="course-accordion__header section-header">
              <!-- Contenedor del título y acciones -->
              <div class="course-accordion__title-container section-title-container">
                <!-- Contenedor izquierdo con título -->
                <div class="course-accordion__left">
                  <div class="course-accordion__drag-handle">
                    <app-enfaf-icon svgIconName="move" iconSize="21px" class="course-accordion__drag-icon"> </app-enfaf-icon>
                  </div>
                  <div class="course-accordion__text"> Asignatura {{ getSectionDisplayNumber(i) }}: {{ sectionGroup.value.name }} </div>
                </div>

                <div class="course-accordion__actions">
                  @if (sectionGroup.value.isLocal && canDeleteSection(i)) {
                    <app-enfaf-icon
                      svgIconName="trash"
                      [isButton]="true"
                      class="course-accordion__trash-icon"
                      iconSize="21px"
                      (click)="$event.stopPropagation()"
                      (onClick)="confirmDeleteLocalSection(i)"
                    ></app-enfaf-icon>
                  } @else if (!sectionGroup.value.isLocal && canDeleteSection(i)) {
                    <app-enfaf-icon
                      svgIconName="trash"
                      [isButton]="true"
                      class="course-accordion__trash-icon"
                      iconSize="21px"
                      (click)="$event.stopPropagation()"
                      (onClick)="confirmDeleteRemoteSection(i, courseToEdit.sections[i])"
                    ></app-enfaf-icon>
                  }

                  <button type="button" class="course-accordion__nav-button">
                    <mat-icon class="course-accordion__chevron-icon" [class.rotated]="sectionPanel.expanded"> expand_more </mat-icon>
                  </button>
                </div>
              </div>
            </mat-expansion-panel-header>

            @if (expandedSections[i]) {
              <div class="subject-content" [formGroup]="getSectionFormGroup(i)">
                <div class="subject-form">
                  <div class="input-field__wrapper">
                    <enfaf-input
                      label="Nombre de la asignatura"
                      errorLabel="Campo requerido"
                      placeholder="Nombre"
                      [control]="sectionGroup.get('name')"
                      [maxlength]="100"
                    >
                    </enfaf-input>
                  </div>

                  <div class="attachment-container">
                    @if (!isLoadingAttachments) {
                      <app-enfaf-input-file-dragger-dark
                        [acceptMultiple]="true"
                        [acceptLimit]="10"
                        [maxFileSize]="250000000"
                        [title]="'Arrastra o suelta aquí'"
                        [buttonText]="'Sube tus archivos'"
                        (filesDropped)="onDropSectionFilesClick($event, i)"
                        [currentFiles]="getSectionAttachments(i)"
                        [localFiles]="courseToEdit.sections[i].filesToUpload"
                        (localFilesUpdated)="onSectionLocalFilesUpdated($event, i)"
                        (currentFileDeleted)="onDeleteRemoteSectionAttachment($event, i)"
                        >>>
                      </app-enfaf-input-file-dragger-dark>
                    }

                    @if (isLoadingAttachments) {
                      <div class="loading-container">
                        <mat-spinner class="white-spinner" color="primary"></mat-spinner>
                        <p class="loading-text">Cargando archivos adjuntos...</p>
                      </div>
                    }
                  </div>

                  <div class="checkbox-field check-subject">
                    <app-enfaf-checkbox class="" [control]="sectionGroup.get('hidden')" (onChange)="onSectionHiddenChange(i, $event)"
                      >Ocultar asignatura</app-enfaf-checkbox
                    >
                  </div>
                </div>

                <div class="module-content" cdkDropList (cdkDropListDropped)="dropModule($event, i)">
                  @for (moduleGroup of getModulesFormArray(i).controls; track moduleGroup.value.courseModuleId; let j = $index) {
                    <mat-expansion-panel
                      cdkDrag
                      (cdkDragStarted)="onModuleDragStarted(i)"
                      class="course-accordion module-accordion"
                      [class.invalid]="isModuleInvalid(i, j)"
                      #modulePanel
                      [expanded]="isModuleExpanded(i, j)"
                      (opened)="onModuleExpand(i, j)"
                      (closed)="expandedModules[i][j] = false"
                    >
                      <mat-expansion-panel-header cdkDragHandle class="course-accordion__header module-header">
                        <div class="course-accordion__title-container module-title-container">
                          <div class="course-accordion__left">
                            <div class="course-accordion__drag-handle">
                              <app-enfaf-icon svgIconName="move" iconSize="21px" class="course-accordion__drag-icon"> </app-enfaf-icon>
                            </div>
                            <div class="course-accordion__text"> Módulo {{ j + 1 }}: {{ moduleGroup.value.name }} </div>
                            @if (hasModuleNotesPendingReview(i, j) || hasModuleQuizPendingReview(i, j)) {
                              <span class="class-notes-review-dot" title="Hay contenido IA pendiente de revisión"></span>
                            }
                          </div>

                          <div class="course-accordion__actions">
                            @if (moduleGroup.value.isLocal && getModulesFormArray(i).controls.length > 1) {
                              <app-enfaf-icon
                                svgIconName="trash"
                                [isButton]="true"
                                class="course-accordion__trash-icon"
                                iconSize="21px"
                                (click)="$event.stopPropagation()"
                                (onClick)="confirmDeleteLocalModule(i, j)"
                              ></app-enfaf-icon>
                            } @else if (!moduleGroup.value.isLocal && getModulesFormArray(i).controls.length > 1) {
                              <app-enfaf-icon
                                svgIconName="trash"
                                [isButton]="true"
                                class="course-accordion__trash-icon"
                                iconSize="21px"
                                (click)="$event.stopPropagation()"
                                (onClick)="confirmDeleteRemoteModule(i, j)"
                              ></app-enfaf-icon>
                            }

                            <button type="button" class="course-accordion__nav-button">
                              <mat-icon class="course-accordion__chevron-icon" [class.rotated]="modulePanel.expanded"> expand_more </mat-icon>
                            </button>
                          </div>
                        </div>
                      </mat-expansion-panel-header>

                      @if (isModuleExpanded(i, j)) {
                        <div [formGroup]="getModuleFormGroup(i, j)" class="module-item-content">
                          <div class="input-field__wrapper">
                            <enfaf-input
                              label="Nombre del módulo"
                              [control]="moduleGroup.get('name')"
                              [maxlength]="100"
                              errorLabel="Campo requerido"
                              placeholder="Nombre del módulo"
                            >
                            </enfaf-input>
                          </div>

                          <div class="module-visibility-row">
                            <div class="checkbox-field">
                              <app-enfaf-checkbox [control]="moduleGroup.get('hidden')" (onChange)="onModuleHiddenChange(i, j, $event)"
                                >Ocultar módulo</app-enfaf-checkbox
                              >
                            </div>

                            <div class="publish-date-field">
                              <enfaf-datetime-picker-light
                                [control]="$any(moduleGroup.get('publishDate'))"
                                label="Fecha de publicación"
                                placeholder=""
                                [minDate]="minPublishDate(moduleGroup.get('publishDate'))"
                              />
                              @if (moduleGroup.get('publishDate')?.value) {
                                <button
                                  type="button"
                                  mat-icon-button
                                  class="clear-date-btn"
                                  matTooltip="Quitar fecha de publicación"
                                  (click)="clearModulePublishDate(i, j)"
                                >
                                  <mat-icon>close</mat-icon>
                                </button>
                              }
                            </div>
                          </div>

                          <div class="class-content" cdkDropList (cdkDropListDropped)="dropClass($event, i, j)">
                            @for (classGroup of getClassesFormArray(i, j).controls; track classGroup.value.courseClassId; let k = $index) {
                              <mat-expansion-panel
                                cdkDrag
                                (cdkDragStarted)="onClassDragStarted(i, j)"
                                class="course-accordion class-accordion"
                                [class.invalid]="isClassInvalid(i, j, k)"
                                #classPanel
                                [expanded]="isClassExpanded(i, j, k)"
                                (opened)="onClassExpand(i, j, k)"
                                (closed)="expandedClasses[i][j][k] = false"
                              >
                                <mat-expansion-panel-header cdkDragHandle class="course-accordion__header class-header">
                                  <div class="course-accordion__title-container class-title-container">
                                    <div class="course-accordion__left">
                                      <div class="course-accordion__drag-handle">
                                        <app-enfaf-icon svgIconName="move" iconSize="21px" class="course-accordion__drag-icon"> </app-enfaf-icon>
                                      </div>
                                      @if (hasClassMessageEnabled(i, j, k)) {
                                        <app-enfaf-icon svgIconName="message-circle-green" iconSize="21" />
                                      }
                                      <div class="course-accordion__text"> Clase {{ k + 1 }}: {{ classGroup.value.name }} </div>
                                      @if (classGroup.value.notesPendingReview || classGroup.value.quizPendingReview) {
                                        <span class="class-notes-review-dot" title="Contenido IA pendiente de revisión"></span>
                                      }
                                    </div>

                                    <div class="course-accordion__actions">
                                      @if (classGroup.value.isLocal && getClassesFormArray(i, j).controls.length > 1) {
                                        <app-enfaf-icon
                                          svgIconName="trash"
                                          [isButton]="true"
                                          class="course-accordion__trash-icon"
                                          iconSize="21px"
                                          (click)="$event.stopPropagation()"
                                          (onClick)="confirmDeleteLocalClass(i, j, k)"
                                        ></app-enfaf-icon>
                                      } @else if (!classGroup.value.isLocal && getClassesFormArray(i, j).controls.length > 1) {
                                        <app-enfaf-icon
                                          svgIconName="trash"
                                          [isButton]="true"
                                          class="course-accordion__trash-icon"
                                          iconSize="21px"
                                          (click)="$event.stopPropagation()"
                                          (onClick)="confirmDeleteRemoteClass(i, j, k)"
                                        ></app-enfaf-icon>
                                      }

                                      <button type="button" class="course-accordion__nav-button">
                                        <mat-icon class="course-accordion__chevron-icon" [class.rotated]="classPanel.expanded">
                                          expand_more
                                        </mat-icon>
                                      </button>
                                    </div>
                                  </div>
                                </mat-expansion-panel-header>

                                @if (isClassExpanded(i, j, k)) {
                                  <div class="class-item-content" [formGroup]="getClassFormGroup(i, j, k)">
                                    <div class="input-row">
                                      <div class="input-field__wrapper">
                                        <enfaf-input
                                          label="Nombre de la clase"
                                          placeholder="Nombre de la clase"
                                          errorLabel="Campo requerido"
                                          [control]="classGroup.get('name')"
                                          [maxlength]="100"
                                        >
                                        </enfaf-input>
                                      </div>

                                      <div
                                        class="input-field__wrapper"
                                        [class.input-field__wrapper--processing]="processingClassIds.has(classGroup.value.courseClassId)"
                                      >
                                        <enfaf-input
                                          label="ID de video de Vimeo"
                                          placeholder="123456789"
                                          [errorLabel]="
                                            classGroup.get('classVideoUrl')?.hasError('pattern')
                                              ? 'El formato del ID no es válido (9 o 10 dígitos)'
                                              : 'Campo requerido'
                                          "
                                          [control]="classGroup.get('classVideoUrl')"
                                          (paste)="onVimeoIdPaste($event, classGroup)"
                                        >
                                        </enfaf-input>
                                        @if (processingClassIds.has(classGroup.value.courseClassId)) {
                                          <div class="vimeo-processing-status">
                                            <mat-spinner diameter="14"></mat-spinner>
                                            <span>Procesando…</span>
                                          </div>
                                        }
                                      </div>
                                    </div>

                                    <div class="input-field__wrapper">
                                      <app-enfaf-textarea-dark
                                        label="Descripción"
                                        placeholder="Descripción de la clase"
                                        [control]="classGroup.get('description')"
                                      >
                                      </app-enfaf-textarea-dark>
                                    </div>

                                    <!-- Notes AI admin panel (only for saved classes) -->
                                    @if (!classGroup.value.isLocal) {
                                      <app-admin-lesson-notes
                                        [courseClassId]="classGroup.value.courseClassId"
                                        [isBulkGenerating]="isBulkGenerating"
                                        [id]="'lesson-notes-' + classGroup.value.courseClassId"
                                        (notesHasChanges)="onNotesDirtyChange($event)"
                                        (isAutoProcessing)="onClassProcessingChange(classGroup.value.courseClassId, $event)"
                                        (notesReviewStateChanged)="onNotesReviewStateChanged(classGroup, $event)"
                                      >
                                      </app-admin-lesson-notes>

                                      @if (quizFeatureEnabled()) {
                                        <app-admin-quiz-questions
                                          [courseClassId]="classGroup.value.courseClassId"
                                          [isBulkGenerating]="isBulkQuizGenerating"
                                          [hasVideo]="!!classGroup.get('classVideoUrl')?.value && classGroup.get('classVideoUrl')?.valid === true"
                                          (quizHasChanges)="onQuizDirtyChange($event)"
                                          (quizReviewStateChanged)="onQuizReviewStateChanged(classGroup, $event)"
                                        ></app-admin-quiz-questions>
                                      }
                                    }

                                    <div class="attachment-container">
                                      @if (!isLoadingAttachments) {
                                        <app-enfaf-input-file-dragger-dark
                                          [acceptMultiple]="true"
                                          [acceptLimit]="10"
                                          [maxFileSize]="250000000"
                                          [title]="'Arrastra o suelta aquí'"
                                          [buttonText]="'Sube tus archivos'"
                                          (filesDropped)="onDroppedClassResources($event, i, j, k)"
                                          [currentFiles]="getClassAttachments(i, j, k)"
                                          [localFiles]="courseToEdit.sections[i].modules[j].classes[k].filesToUpload"
                                          (localFilesUpdated)="onClassLocalFilesUpdated($event, i, j, k)"
                                          (currentFileDeleted)="onDeleteRemoteClassAttachment($event, i, j, k)"
                                          >>>
                                        </app-enfaf-input-file-dragger-dark>
                                      }

                                      @if (isLoadingAttachments) {
                                        <div class="loading-container">
                                          <mat-spinner class="white-spinner" color="primary"></mat-spinner>

                                          <p class="loading-text">Cargando archivos adjuntos...</p>
                                        </div>
                                      }
                                    </div>

                                    @for (message of getMessageClassesFormArray(i, j, k).controls; track message.value.messageId; let m = $index) {
                                      <app-class-message-config
                                        [group]="getMessageClassFormGroup(i, j, k, m)"
                                        [messageOptions]="messageOptions"
                                        [messages]="messages"
                                        label="Enviar mensaje de Whatsapp al finalizar la clase"
                                      ></app-class-message-config>
                                    }

                                    <div class="checkbox-field">
                                      <app-enfaf-checkbox [control]="classGroup.get('hidden')" (onChange)="onClassHiddenChange(i, j, k, $event)"
                                        >Ocultar clase</app-enfaf-checkbox
                                      >
                                    </div>

                                    @if (canMoveClass(i, j)) {
                                      <div class="class-movement" [class.moving]="movingClassId === classGroup.value.courseClassId">
                                        @if (movingClassId === classGroup.value.courseClassId) {
                                          <div class="input-field__wrapper">
                                            <enfaf-select
                                              label="Asignatura"
                                              name="sectionId"
                                              [control]="movingClassForm.controls.sectionId"
                                              [options]="sectionClassOptions"
                                            >
                                            </enfaf-select>
                                          </div>
                                          <div class="input-field__wrapper">
                                            <enfaf-select
                                              label="Módulo"
                                              name="moduleId"
                                              [control]="movingClassForm.controls.moduleId"
                                              [options]="moduleClassOptions"
                                            >
                                            </enfaf-select>
                                          </div>
                                          <div class="class-movement__actions">
                                            <app-enfaf-icon
                                              [isButton]="true"
                                              svgIconName="check-green"
                                              [isDisabled]="movingClassForm.invalid"
                                              (onClick)="moveClass()"
                                            />
                                            <app-enfaf-icon
                                              svgIconName="x-red"
                                              [isButton]="true"
                                              svgIconName="x-red"
                                              (onClick)="setMovingClassId(null, null, null)"
                                            />
                                          </div>
                                        } @else {
                                          <app-enfaf-button
                                            type="dark-blue"
                                            height="41px"
                                            (onClick)="
                                              setMovingClassId(
                                                classGroup.value.courseClassId,
                                                courseToEdit.sections[i].modules[j].courseModuleId,
                                                courseToEdit.sections[i].courseSectionId
                                              )
                                            "
                                            >Mover clase a otro módulo/asignatura/año</app-enfaf-button
                                          >
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </mat-expansion-panel>
                            }

                            <div class="add-button">
                              <app-enfaf-button
                                class="add-class-button"
                                type="outline"
                                color="primary"
                                height="52px"
                                padding="14px 34px"
                                [setNgStyle]="{ 'font-size': '16px' }"
                                (onClick)="addClass(i, j, getClassesFormArray(i, j).length)"
                              >
                                Añadir clase
                              </app-enfaf-button>
                            </div>
                          </div>

                          <div class="promotion-content">
                            <div class="row">
                              <app-enfaf-switch-dark
                                [control]="getModuleFormGroup(i, j).get('showPromotion')!"
                                [label]="'Mostrar promoción en el módulo ' + (j + 1)"
                                (onChange)="togglePromotion(i, j, { checked: $event })"
                              >
                              </app-enfaf-switch-dark>
                            </div>

                            @if (getModuleFormGroup(i, j).get('showPromotion')?.value) {
                              <div class="promotion-container">
                                <h3 class="promotion-title">Promoción del módulo {{ j + 1 }}</h3>

                                <div class="promotion-form-row">
                                  <div class="promotion-form-group">
                                    <enfaf-input
                                      label="Título de la sección"
                                      placeholder="Título de la sección"
                                      [control]="getModuleFormGroup(i, j).get('promotionTitle')"
                                      errorLabel="Campo requerido"
                                      class="promotion-input"
                                    ></enfaf-input>
                                  </div>

                                  <div class="promotion-form-group">
                                    <enfaf-input
                                      label="Descripción"
                                      placeholder="Descripción"
                                      [control]="getModuleFormGroup(i, j).get('promotionDescription')"
                                      errorLabel="Campo requerido"
                                      class="promotion-input"
                                    ></enfaf-input>
                                  </div>

                                  <div class="promotion-form-row-split">
                                    <div class="promotion-form-group">
                                      <enfaf-input
                                        label="Texto del botón"
                                        placeholder="Texto del botón"
                                        errorLabel="Campo requerido"
                                        [control]="getModuleFormGroup(i, j).get('promotionButtonText')"
                                        class="promotion-input"
                                      ></enfaf-input>
                                    </div>

                                    <div class="promotion-form-group">
                                      <enfaf-input
                                        label="Enlace del botón"
                                        placeholder="Enlace del botón"
                                        [control]="getModuleFormGroup(i, j).get('promotionButtonUrl')"
                                        [errorLabel]="
                                          getModuleFormGroup(i, j).get('promotionButtonUrl')?.hasError('pattern')
                                            ? 'El formato del enlace no es correcto'
                                            : 'Campo requerido'
                                        "
                                        class="promotion-input"
                                      ></enfaf-input>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>

                          @if (canMoveModule(i)) {
                            <div class="module-movement" [class.moving]="movingModuleId === moduleGroup.value.courseModuleId">
                              @if (movingModuleId === moduleGroup.value.courseModuleId) {
                                <div class="input-field__wrapper">
                                  <enfaf-select
                                    label="Asignatura"
                                    name="sectionId"
                                    [control]="movingModuleForm.controls.sectionId"
                                    [options]="sectionModuleOptions"
                                  >
                                  </enfaf-select>
                                </div>
                                <div class="module-movement__actions">
                                  <app-enfaf-icon
                                    [isButton]="true"
                                    svgIconName="check-green"
                                    [isDisabled]="movingModuleForm.invalid"
                                    (onClick)="moveModule()"
                                  />
                                  <app-enfaf-icon
                                    svgIconName="x-red"
                                    [isButton]="true"
                                    svgIconName="x-red"
                                    (onClick)="setMovingModuleId(null, null)"
                                  />
                                </div>
                              } @else {
                                <app-enfaf-button
                                  type="dark-blue"
                                  height="41px"
                                  (onClick)="
                                    setMovingModuleId(courseToEdit.sections[i].modules[j].courseModuleId, courseToEdit.sections[i].courseSectionId)
                                  "
                                  >Mover módulo a otra asignatura/año</app-enfaf-button
                                >
                              }
                            </div>
                          }
                        </div>
                      }
                    </mat-expansion-panel>
                  }

                  <div class="add-button">
                    <app-enfaf-button
                      type="dark-blue"
                      color="primary"
                      height="52px"
                      padding="14px 51px"
                      [setNgStyle]="{ 'font-size': '16px' }"
                      (onClick)="addModule(i, getModulesFormArray(i).length)"
                    >
                      Añadir módulo
                    </app-enfaf-button>
                  </div>
                </div>
              </div>
            }
          </mat-expansion-panel>
        }
      </ng-template>

      @if (!isFpCourse) {
        <!-- Standard/flash courses: flat asignatura list, unchanged from before the FP feature -->
        <div cdkDropList (cdkDropListDropped)="dropSection($event)" class="sections-drop-list">
          <mat-accordion>
            @for (sectionGroup of sectionsFormArray.controls; track sectionGroup.value.courseSectionId; let i = $index) {
              <ng-container
                *ngTemplateOutlet="
                  sectionPanelTpl;
                  context: { i: i, sectionGroup: sectionGroup, dragDisabled: sectionsFormArray.controls.length <= 1 }
                "
              ></ng-container>
            }
          </mat-accordion>
        </div>
      }

      @if (isFpCourse) {
        <!-- FP courses: "Año" is the exact same course-accordion/section-accordion pattern as asignatura,
         one level up, wrapping that year's asignaturas (same card style, collapsible header, own
         "Añadir asignatura" action) — see fp-courses-design-references.md §0 and fp-courses.pen
         (nodes mevgP/p2dAEV). Each year owns its own cdkDropList so drag-reordering never crosses
         years, and an empty year still renders in its correct position with its own add button.
         [multi]="false" (the mat-accordion default, set explicitly for intent) — only one year can
         be open at a time; opening another closes whichever was open, same as this codebase's
         module/class panels enforce manually via expandedModules/expandedClasses. MatAccordion's
         own close-others mechanism fires each closed year's (closed) output, so expandedYears stays
         in sync without any extra code. -->
        <mat-accordion [multi]="false">
          @for (year of courseToEdit.years; track year.courseYearId; let yIndex = $index) {
            <mat-expansion-panel
              class="course-accordion section-accordion year-accordion"
              #yearPanel
              [expanded]="expandedYears[yIndex]"
              (opened)="expandedYears[yIndex] = true"
              (closed)="expandedYears[yIndex] = false"
            >
              <mat-expansion-panel-header class="course-accordion__header section-header">
                <div class="course-accordion__title-container section-title-container">
                  <div class="course-accordion__left">
                    <div class="course-accordion__text">Año {{ year.number }}</div>
                  </div>
                  <div class="course-accordion__actions">
                    @if (courseToEdit.years!.length > 1) {
                      <app-enfaf-icon
                        svgIconName="trash"
                        [isButton]="true"
                        class="course-accordion__trash-icon"
                        iconSize="21px"
                        (click)="$event.stopPropagation()"
                        (onClick)="confirmDeleteYear(yIndex)"
                      ></app-enfaf-icon>
                    }

                    <button type="button" class="course-accordion__nav-button">
                      <mat-icon class="course-accordion__chevron-icon" [class.rotated]="yearPanel.expanded"> expand_more </mat-icon>
                    </button>
                  </div>
                </div>
              </mat-expansion-panel-header>

              <div [formGroup]="getYearFormGroup(yIndex)" class="module-visibility-row">
                <div class="checkbox-field">
                  <app-enfaf-checkbox [control]="getYearFormGroup(yIndex).get('hidden')" (onChange)="onYearHiddenChange(yIndex, $event)"
                    >Ocultar año</app-enfaf-checkbox
                  >
                </div>

                <div class="publish-date-field">
                  <enfaf-datetime-picker-light
                    [control]="$any(getYearFormGroup(yIndex).get('publishDate'))"
                    label="Fecha de publicación"
                    placeholder=""
                    [minDate]="minPublishDate(getYearFormGroup(yIndex).get('publishDate'))"
                  />
                  @if (getYearFormGroup(yIndex).get('publishDate')?.value) {
                    <button
                      type="button"
                      mat-icon-button
                      class="clear-date-btn"
                      matTooltip="Quitar fecha de publicación"
                      (click)="clearYearPublishDate(yIndex)"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </div>
              </div>

              <!-- ENF-2314: Clase 0, the mandatory year-level intro class. Own fetch, but saved
               together with the main "Guardar" via isDirty/saveChanges() — same coordination
               pattern as app-admin-lesson-notes / app-admin-quiz-questions. -->
              <app-admin-class-zero [courseYearId]="year.courseYearId" (classZeroHasChanges)="onClassZeroDirtyChange($event)"></app-admin-class-zero>

              <div cdkDropList (cdkDropListDropped)="dropSection($event, year.courseYearId)" class="sections-drop-list">
                <mat-accordion>
                  @for (i of getYearSectionIndices(year.courseYearId); track courseToEdit.sections[i].courseSectionId) {
                    <ng-container
                      *ngTemplateOutlet="
                        sectionPanelTpl;
                        context: { i: i, sectionGroup: getSectionFormGroup(i), dragDisabled: getYearSectionIndices(year.courseYearId).length <= 1 }
                      "
                    ></ng-container>
                  }
                </mat-accordion>
              </div>

              <div class="add-button">
                <app-enfaf-button
                  color="primary"
                  height="52px"
                  padding="14px 51px"
                  [setNgStyle]="{ 'font-size': '16px' }"
                  (onClick)="addSectionToYear(year.courseYearId)"
                >
                  Añadir asignatura
                </app-enfaf-button>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>

        <div class="add-button">
          <app-enfaf-button color="primary" height="52px" padding="14px 51px" [setNgStyle]="{ 'font-size': '16px' }" (onClick)="addYear()">
            Añadir año
          </app-enfaf-button>
        </div>
      }

      <!-- Botón de acción: Añadir asignatura (cursos no-FP; en FP se añade por año, ver cabeceras de año arriba) + Añadir TFM -->
      <div class="add-button">
        @if (!isFpCourse) {
          <app-enfaf-button
            color="primary"
            height="52px"
            padding="14px 51px"
            [setNgStyle]="{ 'font-size': '16px' }"
            (onClick)="addSection(sectionsFormArray.length)"
          >
            Añadir asignatura
          </app-enfaf-button>
        }
        @if (courseId && !showTfmSection && canConfigureTfm) {
          <app-enfaf-button color="primary" height="52px" padding="14px 51px" [setNgStyle]="{ 'font-size': '16px' }" (onClick)="addTfmSection()">
            Añadir TFM
          </app-enfaf-button>
        }
      </div>

      @if (courseId && showTfmSection && canConfigureTfm) {
        <app-admin-tfm-config [courseId]="courseId" (configExists)="onTfmConfigExists($event)"> </app-admin-tfm-config>
      }
    </form>
  }
</div>

<!-- Footer fijo al final de la página sin fondo -->
<div class="footer">
  <app-enfaf-button
    height="41px"
    color="secondary"
    [disabled]="isSavingCourse"
    class="cancel"
    (onClick)="confirmCancelEditCourseContent()"
    [setNgStyle]="{ 'font-size': '14px' }"
  >
    Cancelar
  </app-enfaf-button>

  <app-enfaf-button
    height="41px"
    color="primary"
    [disabled]="
      isLoadingCourse ||
      isSavingCourse ||
      (courseForm && courseForm.invalid) ||
      (courseForm && !courseForm.dirty && !hasUnsavedNotes && !hasUnsavedQuizzes && !hasUnsavedClassZero)
    "
    class="save"
    (onClick)="saveCourseContent()"
    [setNgStyle]="{ 'font-size': '14px' }"
  >
    Guardar
  </app-enfaf-button>
</div>
